import React, { useState, useEffect } from "react";
import { useForm, Controller } from "react-hook-form";
import { useDispatch } from "react-redux";
import { Row, Col, Label, Alert } from "reactstrap";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-material.css";
import PopupMsgWrapper from "../../common/PopupMsgWrapper";
import "react-dropzone-uploader/dist/styles.css";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { getAllBlockReasonListService, getAllSupplierSpecializationService, getCommercialReasonService, getDivisionByCategoryService, getPaymentTermsService, getSelectSupplierCategoryService, getSelectSupplierPlant, getSelectSupplierService, getSourceOfOrigin, saveNewBlockSupplier } from "../VendorNeedForm/Actions";
import { alphaNumeric, alphaNumericHavells, checkWhiteSpaces, email, notify, numberHavells, userDetails } from "../../../helper";
import { SearchableSelectHookForm, TextAreaHookForm, TextFieldHookForm } from "../../layout/HookFormInputs";
import TooltipCustom from "../../common/Tooltip";
import FileUpload from "../FileUpload";
import HeaderTitle from "../../common/HeaderTitle";
import Toaster from "../../common/Toaster";
import axiosHelper from "../../../axiosHelper";
import { API } from "../../../config/constants";
import LoaderCustom from "../../common/LoaderCustom";
import { getCountryService, getTypeEstablishment, getUserByVendorUnblocking, getYearOfBuisnessService } from "./Actions";
import confirmImgMain from "../../../assests/images/logo/havells-h-logo.svg";
function AddUnblockingRequest(props) {
    const {
        register,
        handleSubmit,
        watch,
        setValue,
        getValues,
        setError,
        trigger,
        formState: { errors },
        control,
    } = useForm({
        defaultValues: {
            // NewBusinessVertical: "true",
            // Importlocalization: "true",
            // DuetoSingleSource: "true",
            // DiscussionWithNDTTeam: "true",
            // NewLocationAddedByExistingSupplier: "true",
            // Commercial: "true",
            // Other: "true",
            // CostSheet: "true",
            // ReplacementExistingVendor: "true",
            // CostSaving: "true",
            // ExistingSupplierAvialableAndDiscussion: "true",
            // supplierOrigin: "1",
            // HasSisterConcernWithQRG: "true",
            // HasISO9001OrIATF16949: "true",
            // HasRelationWithQRGEmployees: "true",
            // IsRegisteredUnderMSMEDAct: "true",
            // HasFactoryLicense: "true",
            // VendorRelation: "true",
        },
        mode: "onChange",
        reValidateMode: "onChange",
    });
    const urlParams = new URLSearchParams(window.location.search);

    const supplierId = urlParams.get("id");
    const modeEdit = urlParams.get("mode");

    const VendorRegID = urlParams.get("VendorRequirementRegistrationId");
    const SupplierCodeId = urlParams.get("SupplierCode");
    const vendorID = VendorRegID || props?.VendorRegID;
    const supplierCode = SupplierCodeId || props?.SupplierCodeId;
    const [hasSupplierCodeChanged, setHasSupplierCodeChanged] = useState(false);
    const [isSupplierCodeValid, setIsSupplierCodeValid] = useState(false);
    const [supplierOrigin, setSupplierOrigin] = useState("1");
    const [selectedEstablishmentType, setSelectedEstablishmentType] =
        useState("");
    const [supplierSpecialization, setSupplierSpecialization] = useState([]);
    const [yearOfBuisness, setYearOfBuisness] = useState([]);
    const [showPageLoader, setShowPageLoader] = useState(false);
    const [emailforUnblockingRequest, setEmailForUnblockingRequest] = useState(null)
    const [masterCurrencyList, setCurrencyMasterList] = useState([]);
    const [currencyScaleData, setCurrencyScaleData] = useState([]);
    const [countryList, setCountryList] = useState([]);
    const [stateOptionData, setOptionData] = useState([]);
    const [cityOptionData, setCityOptionData] = useState([]);
    const [howDidYouHearAboutData, setHowDidYouHearAbout] = useState(null);
    const [districtOptionData, setDistrictOptionData] = useState([]);
    const [setDisable, setSetDisable] = useState(false);
    const [establishment1, setEstablishment] = useState([]);
    const [showPopup, setShowPopup] = useState(false);
    const [showSupplierOriginPopup, setShowSupplierOriginPopup] = useState(false);
    const [loading, setLoading] = useState(false);
    const [paymentTermsMaster, setPaymentTermsMaster] = useState([]);
    const [costSaving, setCostSaving] = useState('');


    const [dataVendorRegistrationIdData, setDataVendorRegistrationByIdData] =
        useState(null);
    const [remarks, setRemarks] = useState("");
    // Event handler to update the state when the value changes
    const handleRemarksChange = (event) => {
        setRemarks(event.target.value);
    };
    const [uploadEvidenceFile, setUploadEvidenceFile] = useState({
        fileName: dataVendorRegistrationIdData?.CompanyProfileDocumentName,
        base64String: "",
        fileType: "",
    });
    const [isoFile, setIsoFile] = useState({
        fileName: dataVendorRegistrationIdData?.CompanyProfileDocumentName,
        base64String: "",
        fileType: "",
    });

    const [companyProfile, setCompanyProfile] = useState({
        fileName: dataVendorRegistrationIdData?.CompanyProfileDocumentName,
        base64String: "",
        fileType: "",
    });
    const [saveRiskFile, setSaveRiskFile] = useState({
        fileName: dataVendorRegistrationIdData?.SaveriskDocumentName,
        base64String: "",
        fileType: "",
    });
    const [selectedCategoryCostSheet, setSelectedCategoryCostSheet] = useState(false);


    const [selectedPotentialSupplierList, setSelectedpotentialSupplierList] =
        useState([]);
    const [hasGSTINChanged, setHasGSTINChanged] = useState(false);
    const [isGstValid, setIsGstValid] = useState(false);
    const [sendToApiPotentialData, setSendToApiPotentialData] = useState(null);
    const [
        selectedPotentialSupplierListPlant,
        setSelectedpotentialSupplierListPlant,
    ] = useState([]);
    const [popupLoader, setPopupLoader] = useState(false);
    const [idDataFromSupplier, setIdByDataInSupplierNeedForm] = useState(false);
    const [reasonBlockData, setReasonBlockData] = useState([])
    const [selectedCategory, setSelectedCategory] = useState([]);
    const [checkDivison, setCheckDivison] = useState(false);
    const [sourceOfOriginList, setSourceOfOriginList] = useState([]);
    const [trackkingApplicationId, settrackkingApplicationId] = useState({});
    const [commercialReasonMaster, setCommercialReasonMaster] = useState(null);
    const [contryId, setCountryId] = useState(null);
    const history = useHistory();



    useEffect(() => {
        const fetchData = async () => {
            try {
                // Fetch all necessary data
                await Promise.all([
                    getYearOfBuisnessCorporation(),
                    getSelectSupplierNeedForm(),
                    getAllSupplierSpecialization(),
                    getOriginOfSourceRef(),
                    getSelectSupplierNeedFormPlant(),
                    getPaymentTermsOfVendorNeedForm(),
                    getCommercialReasonOfVendorNeedForm(),
                    getAllBlockReasonList(),
                    getSelectSupplierCategory(),
                    getCountryMasterList(),
                    getTypeOfEstablishment()
                ]);
            } catch (error) {

                // Handle errors if needed
            } finally {
                setLoading(false); // Set loading to false after data fetching completes or fails
            }
        };
        void fetchData();


    }, []); // Depend on dataForRequest to trigger fetch and loading state
    useEffect(() => {
        const vendorID = VendorRegID || props?.VendorRegID;
        const supplierCode = SupplierCodeId || props?.SupplierCodeId;
        if ((vendorID || supplierCode) && selectedCategory.length) {
            setLoading(true); // Set loading to true when dataForRequest changes
            getUserByVendorUnblocking(vendorID, supplierCode)
                .then((res) => {
                    const userData = res?.Data || {};
                    setDataVendorRegistrationByIdData(userData);


                    if (userData?.GISTINNumber && modeEdit === "edit") {
                        setIsGstValid(true)
                    }
                    setValue(
                        "WhatPercentAnnuallyCostSaving",
                        userData?.WhatPercentAnnuallyCostSaving
                    );
                    setCountryId(userData?.CountryId);
                    setCostSaving(userData?.CostSaving?.toString() || '');
                    // Update state with fetched user data
                    setValue("VendorCode", userData?.VendorCode || '');
                    setValue("Remarks", userData?.WhyVendorUnblockRemark || '');
                    setValue("VendorName", userData?.VendorName || '');
                    setValue("PANNo", userData?.PAN || '');
                    setValue("GISTINNumber", userData?.GSTIN || '');
                    setValue("ExpectedBusiness", userData?.ExpectedBusiness);
                    void handleCategoryDivisionMaster(userData?.CategoryId, false);
                    setIsoFile({
                        fileName: userData?.CostSheetDocumentName,
                        base64String: "",
                        fileType: "",
                    });
                    setValue("CostSheetDocument", userData?.CostSheetDocumentName);
                    setValue(
                        "HowMuchAnnuallyCostSaving",
                        userData?.HowMuchAnnuallyCostSaving
                    );
                    setValue("CostSheetDocument", userData?.CostSheetDocumentName);
                    setValue("costSavingDocument", userData?.CostSheetDocumentName);
                    setUploadEvidenceFile({
                        fileName: userData?.CostSavingDocumentName,
                        base64String: "",
                        fileType: "",
                    });
                    // getSelectSupplierCategory();
                    setValue("Division", userData?.DivisionId ? {
                        value: userData?.DivisionId,
                        label: userData?.DivisionName
                    } : null);
                    setValue("Plant", userData?.PlantId ? {
                        value: userData?.PlantId,
                        label: userData?.PLantName
                    } : null);
                    setValue("CommercialReason", userData?.CommercialReasonId ? {
                        value: userData?.CommercialReasonId,
                        label: userData?.CommercialReasonName
                    } : null);
                    setValue("Importlocalization", userData?.Importlocalization?.toString() || '');
                    // setValue("Commercial", userData?.CommercialReason?.toString() || '');
                    setValue("DuetoSingleSource", userData?.DuetoSingleSource?.toString() || '');
                    setValue("CostSheet", userData?.CostSheet?.toString() || '');
                    setValue("CostSaving", userData?.CostSaving?.toString() || '');
                    // setCostSaving(userData?.CostSaving?.toString() || '');
                    setValue("Category", userData?.CategoryId ? {
                        value: userData?.CategoryId,
                        label: userData?.CategoryName
                    } : null);
                    setValue("ReasonOfBlocking", userData?.ReasonOfBlockingId ? {
                        value: userData?.ReasonOfBlockingId || '',
                        label: userData?.ReasonOfBlockingDesc || ''
                    } : null);
                    setValue("PaymentTerms", userData?.PaymentTermId ? {
                        value: userData?.PaymentTermId || '',
                        label: userData?.PaymentTermName || ''
                    } : null);
                    setValue("Email", userData?.EmailAddress || '');
                    setValue("MobileNo", userData?.ContactNo || '');
                    setValue("SupplierOrigin", userData?.SupplierOrigin || '');
                    setValue("CompanyName", {
                        value: userData?.SupplierRepositoryRequestId || '',
                        label: userData?.SupplierVendorName || ''
                    });
                    setValue("SupplierSpecialization", userData?.SupplierSpecialization ? {
                        value: userData?.SupplierSpecialization || '',
                        label: userData?.SpecializationName || ''
                    } : null);
                    setSupplierOrigin(userData?.SupplierOrigin?.toString() || '');
                })
                .catch((error) => {

                    // Handle errors if needed
                })
                .finally(() => {
                    setLoading(false); // Set loading to false after getUserByVendorUnblocking completes or fails
                });
        }
    }, [VendorRegID, selectedCategory, SupplierCodeId])

    // useEffect(() => {
    //     if (costSaving === "true") {
    //         setValue("CostSheet", "true");
    //         setValue("CostSaving", "true");
    //     } else {
    //         setValue("CostSheet", "");
    //     }
    // }, [costSaving, setValue]);

    const handleCostSheetDocumentDelete = () => {
        setIsoFile((p) => ({
            ...p,
            isRemove: true,
        }));
    };
    const handleUploadEvidenceDelete = () => {
        setUploadEvidenceFile((p) => ({
            ...p,
            isRemove: true,
        }));
    };



    const onPopupConfirm = async () => {
        setPopupLoader(true); // Start loader
        history.push('/supplier-unblocking-request')
    };

    const handleSupplierRadioChange = (event) => {
        // setShowSupplierOriginPopup(true);
        setSupplierOrigin(event.target.id);
    };

    const onConfirmSupplierPopup = (event) => {
        setShowSupplierOriginPopup(false);
        // Any other logic you want to perform on confirmation
    };

    const dispatch = useDispatch();


    const getTypeOfEstablishment = () => {
        getTypeEstablishment()
            .then((res) => {
                setEstablishment(res?.Data);
            })
            .catch(() => { });
    };


    const getYearOfBuisnessCorporation = () => {
        getYearOfBuisnessService()
            .then((res) => {
                setYearOfBuisness(res?.Data);
            })
            .catch(() => { });
    };

    const getCountryMasterList = () => {
        getCountryService()
            .then((res) => {
                setCountryList(res?.Data);
            })
            .catch(() => { });
    };

    const getSelectSupplierNeedForm = () => {
        getSelectSupplierService()
            .then((res) => {
                setSelectedpotentialSupplierList(res?.Data);
            })
            .catch(() => { });
    };
    const getAllBlockReasonList = () => {
        getAllBlockReasonListService()
            .then((res) => {
                setReasonBlockData(res?.Data);
            })
            .catch(() => { });
    };
    const getSelectSupplierNeedFormPlant = () => {
        getSelectSupplierPlant()
            .then((res) => {
                setSelectedpotentialSupplierListPlant(res?.Data);
            })
            .catch(() => { });
    };
    const getSelectSupplierCategory = () => {
        getSelectSupplierCategoryService()
            .then((res) => {
                if (res && res?.IsSuccessful) {
                    setSelectedCategory(res?.Data);
                }
            })
            .catch(() => { });
    };
    const getAllSupplierSpecialization = () => {
        getAllSupplierSpecializationService()
            .then((res) => {
                setSupplierSpecialization(res?.Data);
            })
            .catch(() => { });
    };
    const getPaymentTermsOfVendorNeedForm = () => {
        getPaymentTermsService()
            .then((res) => {
                setPaymentTermsMaster(res?.Data);
            })
            .catch(() => { });
    };
    const getOriginOfSourceRef = () => {
        getSourceOfOrigin()
            .then((res) => {
                setSourceOfOriginList(res?.Data);
            })
            .catch(() => { });
    };
    const getCommercialReasonOfVendorNeedForm = () => {
        getCommercialReasonService()
            .then((res) => {
                setCommercialReasonMaster(res?.Data);
            })
            .catch(() => { });
    };
    const validateGSTIN = async (gstNumber, notifyMsg = true) => {
        if (gstNumber) {
            setShowPageLoader(true);
            gstNumber = gstNumber.toUpperCase();
            let url = `${API.GSTValidate}?GSTIN=${gstNumber}`;
            const request = axiosHelper.get(url);
            request
                .then((response) => {
                    if (response.data.IsSuccessful) {
                        setIsGstValid(true);
                        setShowPageLoader(false);
                        if (notifyMsg) {
                            notify.success(response.data.FriendlyMessage);
                        }
                    }
                })
                .catch((error) => {
                    if (error.response && error.response.status === 400) {
                        const responseData = error.response.data;
                        if (!responseData.IsSuccessful) {
                            setIsGstValid(false);
                            setShowPageLoader(false);
                            setError('GISTINNumber', {
                                type: 'manual',
                                message: responseData.FriendlyMessage,
                            });
                            return false;
                        }
                    }
                });
        }
    };
    const handleEvidenceUpload = (file) => {
        // Check if the ile size is less than or equal to 5 MB (5 * 1024 * 1024 bytes)
        if (file?.size <= 5 * 1024 * 1024) {
            const reader = new FileReader();
            reader.onload = (event) => {
                let base64String = event.target.result;

                // Remove the data type prefix
                base64String = base64String.replace(/^data:(.*?);base64,/, "");
                // Check if the file type is allowed (PDF, JPG, JPEG, PNG)
                const allowedFileTypes = [
                    "application/pdf",
                    "application/msword", // .doc files
                    "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // .docx files
                    "application/vnd.ms-excel", // .xls files
                    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // .xlsx files
                ];
                const isTypeValid = allowedFileTypes.includes(file.type);

                if (!isTypeValid) {
                    Toaster.error(
                        "Unsupported file type. Please choose a file with one of the following formats: PDF, Word (DOC/DOCX),Excel (XLS/XLSX)."
                    );
                    // Handle the case where the file type is not allowed

                    return;
                }
                // Pass file name, base64String, and fileType to setGstinFile
                setUploadEvidenceFile({
                    fileName: file?.name,
                    base64String,
                    fileType: file?.type,
                });
                setValue("costSavingDocument", {
                    fileName: file?.name,
                    base64String,
                    fileType: file?.type,
                })
                trigger('costSavingDocument')
            };
            reader.readAsDataURL(file);
        } else {
            Toaster.error("File size exceeds 5 MB. Please choose a smaller file.");
            // Handle the case where the file size exceeds 5 MB or the file type is not allowed
        }
    };

    const handleCostSheetDocument = (file) => {
        // Allowed file types for cost sheet document
        const allowedFileTypes = [
            "application/pdf",
            "application/msword", // .doc files
            "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // .docx files
            "application/vnd.ms-excel", // .xls files
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // .xlsx files
        ];

        // Check if the file type is allowed
        if (!allowedFileTypes.includes(file.type)) {
            Toaster.error(
                "Unsupported file type. Please choose a file with one of the following formats: PDF, Word (DOC/DOCX),Excel (XLS/XLSX)."
            );
            // Unsupported file type

            return; // Exit the function if file type is not allowed
        }

        // Check if the file size is less than or equal to 5 MB (5 * 1024 * 1024 bytes)
        if (file.size > 5 * 1024 * 1024) {
            Toaster.error("File size exceeds 5 MB. Please choose a smaller file.");
            // File size exceeds 5 MB

            return; // Exit the function if file size is too large
        }

        // Proceed with reading the file if both conditions are met
        const reader = new FileReader();

        reader.onload = (event) => {
            if (event.target?.result) {
                let base64String = event.target.result;

                // Remove the data type prefix
                base64String = base64String.replace(/^data:(.*?);base64,/, "");

                // Set the cost sheet document details
                setIsoFile({ fileName: file.name, base64String, fileType: file.type });
                setValue("CostSheetDocument", {
                    fileName: file?.name,
                    base64String,
                    fileType: file?.type,
                })
                trigger('CostSheetDocument')
            }
        };

        // Read the file as a Data URL
        reader.readAsDataURL(file);
    };





    /**
     * @method renderListing
     * @description RENDER LISTING IN DROPDOWN
     */
    const renderListing = (label) => {
        if (label === "CompanyName") {
            return selectedPotentialSupplierList.map((potentialSupplierData) => ({
                value: potentialSupplierData.Id,
                label: potentialSupplierData.SupplierName,
            }));
        }
        if (label === "PlantData") {
            return selectedPotentialSupplierListPlant?.map((plantData) => ({
                value: plantData.Id,
                label: plantData.PlantName,
            }));
        }
        if (label === "ReasonBlockData") {
            return reasonBlockData?.map((reasonblock) => ({
                value: reasonblock.Id,
                label: reasonblock.Name,
            }));
        }
        if (label === "CategoryData") {
            return selectedCategory.map((category) => ({
                value: category.Id,
                label: category.Name,
            }));
        }
        // if (label === "CategoryData") {
        //     const mappedArray = selectedCategory.map((category) => ({
        //       value: category.Id,
        //       label: category.Name,
        //     }));

        //     return mappedArray;
        //   }
        if (label === "SupplierSpecializationData") {
            return supplierSpecialization?.map((supplierSpecialization) => ({
                value: supplierSpecialization.Id,
                label: supplierSpecialization.SpecializationName,
            }));
        }
        if (label === "PaymentTermsData") {
            return paymentTermsMaster?.map((paymentterms) => ({
                value: paymentterms.Id,
                label: paymentterms.Name,
            }));
        }
        if (label === "yearOfBuisness") {
            return yearOfBuisness.map((yearOfBuisnessIncorporation) => ({
                value: yearOfBuisnessIncorporation.Id,
                label: yearOfBuisnessIncorporation.Name,
            }));
        }
        if (label === "SupplierOriginResources") {
            return sourceOfOriginList.map((yearOfBuisnessIncorporation) => ({
                value: yearOfBuisnessIncorporation.Id,
                label: yearOfBuisnessIncorporation.SourceName,
            }));
        }

        if (label === "commercialReasonMasterData") {
            return commercialReasonMaster?.map((commercialReasonMaster) => ({
                value: commercialReasonMaster.Id,
                label: commercialReasonMaster.Name,
            }));
        }
        if (label === "currencyList") {
            return masterCurrencyList.map((yearOfBuisnessIncorporation) => ({
                value: yearOfBuisnessIncorporation.PCId,
                label: yearOfBuisnessIncorporation.CurrencyName,
            }));
        }
        if (label === "DivisionData") {
            return currencyScaleData?.map((yearOfBuisnessIncorporation) => ({
                value: yearOfBuisnessIncorporation.Id,
                label: yearOfBuisnessIncorporation.Name,
            }));
        }
        if (label === "Country") {
            // Check if supplier origin is set and remove India from the listing
            const filteredCountryList =
                supplierOrigin === "2"
                    ? countryList.filter((country) => country.Name !== "India")
                    : countryList;

            return filteredCountryList.map((yearOfBuisnessIncorporation) => ({
                value: yearOfBuisnessIncorporation.Id,
                label: yearOfBuisnessIncorporation.Name,
            }));
        }
        if (label === "State") {
            return stateOptionData.map((yearOfBuisnessIncorporation) => ({
                value: yearOfBuisnessIncorporation.Id,
                label: yearOfBuisnessIncorporation.Name,
            }));
        }
        if (label === "District") {
            return districtOptionData.map((yearOfBuisnessIncorporation) => ({
                value: yearOfBuisnessIncorporation.Id,
                label: yearOfBuisnessIncorporation.Name,
            }));
        }
        if (label === "City") {
            return cityOptionData.map((yearOfBuisnessIncorporation) => ({
                value: yearOfBuisnessIncorporation.Id,
                label: yearOfBuisnessIncorporation.City,
            }));
        }
    };


    const handleSelectChange = (value) => {
        setSelectedEstablishmentType(value);
    };
    /**
     * @method cancel
     * @description used to Reset form
     */
    const cancel = () => {
        modeEdit === "edit" ? history.push('/supplier-unblocking-request') : history.push('/supplier-list-all');
    };

    // const validateAtLeastOneOption = (values) => {
    //     return values.ImportLocalization || values.DuetoSingleSource || values.Commercial || values.CostSaving || values.CostSheet;
    // };

    const onSubmit = async (data, e, isSent) => {
        // const GISTINNumber = data?.GISTINNumber;
        // 
        // // 
        // // if (GISTINNumber && !checkStateForGSTIN(GISTINNumber) && supplierOrigin == 1) {
        // //     notify.error("Please select the correct state for provided GSTIN Number");
        // //     return;
        // //   }

        // if (!isGstValid && GISTINNumber && supplierOrigin == 1) {
        //     // notify.error("The provided GSTIN number is invalid.");
        //     setError('GISTINNumber', {
        //       type: 'manual',
        //       message: "The provided GSTIN number is invalid.",
        //     });
        //     return;
        //   }
        const { Importlocalization, DuetoSingleSource, Commercial, CostSaving, CostSheet } = data;


        // eslint-disable-next-line eqeqeq
        if (Importlocalization == false && DuetoSingleSource == false && Commercial == false && CostSaving == false && CostSheet == false) {
            Toaster.error("Please select at least one option  is mandatory.");
            return;
        }
        // if (!validateAtLeastOneOption(data)) {
        //     Toaster.error("Please select at least one option.");
        //     return;
        // }
        const userDetail = userDetails();
        let otherSpecializationString = Array.isArray(data?.SupplierSpecialization)
            ? data.SupplierSpecialization.map((item) => item.value).join(",")
            : String(data?.SupplierSpecialization?.value);

        const createFilePayload = (file, urlKey) => {
            if (file?.base64String) return file;
            if (file?.isRemove) return { fileName: dataVendorRegistrationIdData?.[urlKey], base64String: "", fileType: "" };
            return null;
        };
        // const createFilePayload = (file, urlKey) => {
        //     if (file?.base64String) return file;  // For new uploads
        //     if (file?.isRemove) return { fileName: dataVendorRegistrationIdData?.[urlKey], base64String: "", fileType: "" };  // For removed files
        //     if (modeEdit === 'edit' && dataVendorRegistrationIdData?.[urlKey]) {
        //         return { fileName: dataVendorRegistrationIdData?.[urlKey], base64String: "", fileType: "" };  // For existing files in edit mode
        //     }
        //     return null;
        // };

        const payload = {
            VendorName: data?.VendorName,
            CompanyName: data?.CompanyName?.value,
            Plant: String(data?.Plant?.value),
            Category: data?.Category?.value,
            Division: data?.Division?.value,
            SupplierSpecialization: otherSpecializationString,
            SupplierOrigin: supplierOrigin,
            VendorRelation: false,
            SupplierOriginSources: data?.SupplierOriginSources?.value,
            ContactPersonName: data?.ContactPersonName,
            EstablishmentRemarks: data?.EstablishmentRemarks,
            ContactPersonDesignation: data?.ContactPersonDesignation,
            YearOfBusinessIncorporation: data?.YearOfBusinessIncorporation?.value,
            PaymenttermsRemarks: data?.PaymenttermsRemarks,
            costSavingDocument: createFilePayload(uploadEvidenceFile, 'CostSavingDocumentUrl'),
            PaymentTerms: data?.PaymentTerms?.value,
            VendorCompanyProfileDocument: createFilePayload(companyProfile, 'CompanyProfileDocumentUrl'),
            saveriskDocument: createFilePayload(saveRiskFile, 'SaveriskDocumentUrl'),
            costSheetDocument: createFilePayload(isoFile, 'CostSheetDocumentUrl'),
            IsBlockedVendor: 1,
            MobileNo: data?.MobileNo,
            ExpectedBusiness: parseInt(data.ExpectedBusiness),
            Email: data?.Email,
            Country: contryId,
            State: data?.State?.value,
            District: data?.District,
            City: data?.City,
            NewBusinessVertical: data?.NewBusinessVertical,
            Importlocalization: data?.Importlocalization,
            DuetoSingleSource: data?.DuetoSingleSource,
            CostSaving: data?.CostSaving,
            CostSheet: data?.CostSheet,
            ReplacementExistingVendor: data?.ReplacementExistingVendor,
            VendorCode: data?.VendorCode,
            ExistingPaymentTerms: data?.ExistingPaymentTerms,
            Commercial: data?.Commercial,
            CommercialReason: data?.CommercialReason?.value,
            Other: data?.Other,
            OtherReason: data?.OtherReason,
            CompanyProfileWebsite: data?.CompanyProfileWebsite,
            SupplierServiceDescription: data?.SupplierServiceDescription,
            ExistingSupplierAvialableAndDiscussion: data?.ExistingSupplierAvialableAndDiscussion,
            ExistingSupplierAvialableAndDiscusionComment: data?.ExistingSupplierAvialableAndDiscusionComment,
            ExistingSupplierFeedback: data?.ExistingSupplierFeedback,
            DiscussionWithNDTTeam: data?.DiscussionWithNDTTeam,
            DiscussionWithNDTTeamComment: data?.DiscussionWithNDTTeamComment,
            LocationChangeOfExistingSupplier: data?.LocationChangeOfExistingSupplier?.value,
            ReasonOfBlockingCode: data?.ReasonOfBlocking?.value,
            NewLocationAddedByExistingSupplier: data?.NewLocationAddedByExistingSupplier,
            NewLocationAddedByExistingSupplierComment: data?.NewLocationAddedByExistingSupplierComment,
            WhyVendorUnblockRemark: remarks,
            HowMuchAnnuallyCostSaving: parseInt(data?.HowMuchAnnuallyCostSaving),
            WhatPercentAnnuallyCostSaving: parseInt(data?.WhatPercentAnnuallyCostSaving),
            EstimatedStartOfSuppies: data?.EstimatedStartOfSuppies,
            EmployeeId: parseInt(userDetail?.EmployeeId),
            SupplierRepositoryRequestId: null,
            VendorRequirementRegistrationId: modeEdit == 'edit' ? VendorRegID : 0,
            GSTIN: data?.GISTINNumber,
            PAN: data?.PANNo
        };


        setSetDisable(true); // Disable the form before the async operation

        try {
            if (vendorID || supplierCode) {
                const res = await dispatch(saveNewBlockSupplier(payload));
                if (res && res?.IsSuccessful) {
                    Toaster.success(res?.Data?.Message);
                    settrackkingApplicationId(res?.Data);
                    setEmailForUnblockingRequest(res?.Data?.Email);

                    const queryParams = new URLSearchParams(window.location.search);
                    const modeEdit = queryParams.get('mode');

                    if (modeEdit !== 'edit') {
                        setShowPopup(true);
                    } else {
                        history.push('/supplier-unblocking-request');
                    }

                    // history.push("/vendor-need-list");
                } else if (res?.response?.data?.ErrorMessage) {
                    Toaster.error(res?.response?.data?.ErrorMessage);
                }
            }
        } catch (error) {
            Toaster.error(error?.response?.data?.ErrorMessage);
        } finally {
            setSetDisable(false); // Always enable the form after the async operation
        }
    };




    const validatePANByGstin = (value) => {
        const PANNo = getValues("PANNo"); // Get GSTIN value from the first input field
        const gstinPAN = value?.substring(2, 12); // Extract PAN from GSTIN
        if (PANNo !== gstinPAN && PANNo && value) {
            return "GSTIN and PAN number do not match.";
        }
        return true;
    };



    const handleCategoryDivisionMaster = async (value, emptyOther = true) => {
        // Show loader when category changes
        setLoading(true);

        let categoryId = value?.value ? value?.value : value;

        const selectedCat = selectedCategory?.find(
            (item) => item?.Id === categoryId
        );
        console.log('selectedCat: ', selectedCat);
        // Set cost sheet requirement flag based on category selection
        const isCostSheetRequired = selectedCat?.IsCostSheet === true;
        setSelectedCategoryCostSheet(isCostSheetRequired ? "true" : "false");

        // Update form validation for CostSheetDocument based on requirement
        if (isCostSheetRequired) {
            setValue("CostSheet", "true");
        }

        setCheckDivison(selectedCat?.IsDivision == true ? false : true);

        try {
            const currencyScaleResponse = await getDivisionByCategoryService(categoryId);
            setCurrencyScaleData(currencyScaleResponse?.Data?.VendorCategory);

            if (emptyOther) {
                setValue("Division", null);
            }
        } catch (error) {
            console.error("Error fetching division data:", error);
            // Handle error if needed
        } finally {
            // Hide loader when done
            setLoading(false);
        }
    }


    const TrackApplicationMessage = () => {
        return (
            <div className="hl-track-modal">
                <div className="fa-success-icon">
                    <i className="fa fa-check-circle-o" aria-hidden="true"></i>
                </div>
                <p className="mb-2">Samarthaya Unblocking request application no <strong>{trackkingApplicationId?.ApplicationNo}</strong> for <br />Supplier code - <strong>{trackkingApplicationId?.VendorCode}</strong>, is submitted & is pending for approval.</p>
                {/* <p>We will keep you posted about the progress on email id <strong>{emailforUnblockingRequest}</strong></p> */}
            </div>
        );
    };
    if (setDisable) {
        return (
            <div>
                {" "}
                <LoaderCustom customClass="simulation-Loader" />
            </div>
        ); // Render loading indicator if loading is true
    }
    /**
     * @method render
     * @description Renders the component
     */
    const closeSupplierPopUp = () => {
        setShowSupplierOriginPopup(false);
    };


    const validateSupplierCode = async (supplierCode, notifyMsg = true) => {
        if (supplierCode) {
            setLoading(true);
            supplierCode = supplierCode.toUpperCase();
            let url = `${API.checkSupplierCodeIsValid}?vendorCode=${supplierCode}`;
            const request = axiosHelper.get(url);
            request
                .then((response) => {
                    if (response.data.IsSuccessful) {
                        setLoading(false);
                        setIsSupplierCodeValid(true);
                        if (notifyMsg) {
                            notify.success(response.data.FriendlyMessage);
                        }
                    }
                })
                .catch((error) => {
                    if (error.response && error.response.status === 400) {
                        const responseData = error.response.data;
                        if (!responseData.IsSuccessful) {
                            setLoading(false);
                            setIsSupplierCodeValid(false);
                            setError("VendorCode", {
                                type: 'manual',
                                message: responseData.ErrorMessage,
                            });
                            return false;
                        }
                    }
                });
        }
    };
    if (showPageLoader) {
        return (
            <div>
                {" "}
                <LoaderCustom customClass="simulation-Loader" />
            </div>
        ); // Render loading indicator if loading is true
    } else if (loading) {
        return (
            <div>
                {" "}
                <LoaderCustom customClass="simulation-Loader" />
            </div>
        );
    }

    return (
        <>

            <div className="container-fluid">
                <div className="signup-form">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="shadow-lgg login-formg">
                                <Row className={`filter-row-large`}>
                                    <Col md="4" className="mb-2">
                                        <h1>Supplier Unblocking Request</h1>
                                    </Col>
                                    <Col md="8" className="mb-3 d-flex justify-content-end">
                                        <button
                                            type="button"
                                            className={"apply mt-1"}
                                            onClick={() => history.push(modeEdit === "edit" ? '/supplier-unblocking-request' : '/supplier-list-all')}
                                        >
                                            <div className={"back-icon"}></div>Back
                                        </button>
                                    </Col>
                                </Row>
                                {showPopup && (
                                    <PopupMsgWrapper
                                        confirmImg={confirmImgMain}
                                        firstButtonName={"Ok"}
                                        secondButtonName={false}
                                        header="Unblocking Request"
                                        isOpen={showPopup}
                                        confirmPopup={onPopupConfirm}
                                        message={TrackApplicationMessage()}
                                        iconClass="d-none"
                                        imgClass="hl-img-confirmation d-none"
                                        customClass="popup-wrapper-main hl-track-apppopup"
                                    // closePopUp={false}

                                    />
                                )}
                                <div>
                                    {showSupplierOriginPopup && (
                                        <PopupMsgWrapper
                                            header="Supplier Origin"
                                            isOpen={showSupplierOriginPopup}
                                            closePopUp={closeSupplierPopUp}
                                            confirmPopup={onConfirmSupplierPopup}
                                            message={
                                                <>
                                                    Are you sure you want to change the origin to
                                                    Overseas?
                                                    <Alert
                                                        color="warning"
                                                        className="p-1 mt-3 hl-warning-msg"
                                                    >
                                                        Clicking the OK button will erase the form data on
                                                        the page.
                                                    </Alert>
                                                </>
                                            }
                                        />
                                    )}
                                    <form onSubmit={handleSubmit(onSubmit)}>
                                        <Row className="part-detail-wrapper">
                                            <Col md="3">
                                                <TextFieldHookForm
                                                    {...register(
                                                        "VendorCode"
                                                    )}
                                                    label={`Supplier Code`}
                                                    name={"VendorCode"}
                                                    Controller={Controller}
                                                    rules={{
                                                        required: false,
                                                        validate: {
                                                            checkWhiteSpaces,
                                                            alphaNumeric,
                                                        },
                                                        maxLength: 50,
                                                    }}
                                                    control={control}
                                                    placeholder={"Enter"}
                                                    disabled={true}
                                                    // register={register}
                                                    // className=""
                                                    customClassName={"withBorder mb-0"}
                                                    errors={
                                                        errors.VendorCode
                                                    }
                                                    // disabled={false}
                                                    mandatory={false}
                                                    handleChange={(e) => {
                                                        setIsSupplierCodeValid(false);
                                                        setHasSupplierCodeChanged(true);
                                                        const uppercaseValue = e.target.value.toUpperCase(); // Convert input value to uppercase
                                                        e.target.value = uppercaseValue;
                                                    }}
                                                    onFieldBlur={(e) => {

                                                        if (hasSupplierCodeChanged) {
                                                            validateSupplierCode(e.target.value);
                                                            setHasSupplierCodeChanged(false);
                                                        }
                                                    }} />
                                            </Col>
                                            <Col md="3">
                                                <TextFieldHookForm
                                                    {...register("VendorName")}
                                                    label={`Supplier Name`}
                                                    // rules={{ required: true, }}
                                                    name={"VendorName"}
                                                    rules={{
                                                        required: false,
                                                        validate: { checkWhiteSpaces },
                                                        maxLength: 50,
                                                    }}
                                                    Controller={Controller}
                                                    control={control}
                                                    placeholder={"Enter"}
                                                    register={register}
                                                    handleChange={() => { }}
                                                    // className=""
                                                    customClassName={"withBorder"}
                                                    errors={errors.VendorName}
                                                    disabled={true}
                                                    mandatory={false}
                                                />
                                            </Col>
                                        </Row>
                                        <Row className="part-detail-wrapper">
                                            <Col
                                                md="3"
                                                className="d-flex aliging-items-center justify-content-between hl-title-tooltip"
                                            >
                                                <div className="hl-right-radio">
                                                    <div className="hl-title-tooltip d-flex">
                                                        <HeaderTitle
                                                            title={
                                                                <>
                                                                    Supplier Origin:
                                                                    <span className="asterisk-required">*</span>
                                                                </>
                                                            }
                                                            customClass="mt-2 hl-supplier-title"
                                                        />
                                                        <TooltipCustom
                                                            id="supplierOriginTooltip"
                                                            width="300px"
                                                            tooltipText={
                                                                <>
                                                                    <ul class="hl-tooltip-list">
                                                                        <li>Selected supplier is for {supplierOrigin === "1" ? "Indian" : "Overseas"}.</li>
                                                                        <li>Gray highlighted field can't be changed since it prefilled information during repository approval.</li>
                                                                    </ul>
                                                                </>
                                                            }
                                                        />
                                                    </div>
                                                    <Label
                                                        className="d-inline-block align-middle w-auto pl-1 pr-5 mr-5 pr-4 pt-0 radio-box"
                                                        check
                                                    >
                                                        <input
                                                            type="radio"
                                                            name="supplierOrigin"
                                                            className="zero-based"
                                                            id="1"
                                                            checked={supplierOrigin === "1"}
                                                            onChange={handleSupplierRadioChange}
                                                            disabled={true}
                                                        />
                                                        <span>Indian</span>
                                                    </Label>
                                                    <Label
                                                        className="d-inline-block align-middle w-auto pl0 pt-0 radio-box"
                                                        check
                                                    >
                                                        <input
                                                            type="radio"
                                                            name="supplierOrigin"
                                                            className="vendor-based"
                                                            id="2"
                                                            checked={supplierOrigin === "2"}
                                                            onChange={handleSupplierRadioChange}
                                                            disabled={true}
                                                        />
                                                        <span>Overseas</span>
                                                    </Label>
                                                </div>
                                            </Col>
                                            <Col md="3">
                                                <SearchableSelectHookForm
                                                    {...register("Plant")}
                                                    label="Plant"
                                                    rules={{ required: true }}
                                                    name="Plant"
                                                    placeholder="Select"
                                                    Controller={Controller}
                                                    control={control}
                                                    register={register}
                                                    options={renderListing("PlantData")}
                                                    mandatory={true}
                                                    handleChange={(value) => {
                                                        handleSelectChange(value);
                                                    }}
                                                    errors={errors?.Plant}
                                                    disabled={false}
                                                />
                                            </Col>
                                            <Col md="3">
                                                <SearchableSelectHookForm
                                                    {...register("Category")}
                                                    label="Category"
                                                    rules={{ required: true }}
                                                    name="Category"
                                                    placeholder="Select"
                                                    Controller={Controller}
                                                    control={control}
                                                    register={register}
                                                    options={renderListing("CategoryData")}
                                                    mandatory={true}
                                                    handleChange={(value) => {
                                                        handleCategoryDivisionMaster(value?.value);
                                                    }}
                                                    errors={errors?.Category}
                                                    disabled={VendorRegID ? true : false}
                                                />
                                            </Col>
                                            <Col md="3">
                                                <SearchableSelectHookForm
                                                    {...register("Division")}
                                                    label="Division"
                                                    rules={{ required: !checkDivison }}
                                                    name="Division"
                                                    placeholder="Select"
                                                    Controller={Controller}
                                                    control={control}
                                                    register={register}
                                                    options={renderListing("DivisionData")}
                                                    mandatory={!checkDivison}
                                                    handleChange={(value) => {
                                                        //   handleSelectChange(value);
                                                    }}
                                                    errors={errors?.Division}
                                                    disabled={checkDivison}
                                                />
                                            </Col>
                                            {supplierOrigin == "1" &&
                                                <><Col md="3">
                                                    <TooltipCustom
                                                        id="panNoTooltip"
                                                        tooltipText={<>
                                                            <ul className="hl-tooltip-list">
                                                                <li>Please attach a copy of PAN Card.</li>
                                                                <li>Allowed file formats: PDF, DOC, JPG, PNG.</li>
                                                            </ul>
                                                        </>} />
                                                    <TextFieldHookForm
                                                        {...register("PANNo")}
                                                        label={`PAN Number`}
                                                        name={"PANNo"}
                                                        Controller={Controller}
                                                        handleChange={(e) => {
                                                            const uppercaseValue = e.target.value.toUpperCase(); // Convert input value to uppercase
                                                            e.target.value = uppercaseValue;
                                                        }}
                                                        rules={{
                                                            required: false,
                                                            validate: {
                                                                checkWhiteSpaces,
                                                                // validatePANByGstin,
                                                            },
                                                            pattern: {
                                                                value: /^[A-Z]{5}[0-9]{4}[A-Z]$/,
                                                                message: "Invalid PAN Number format.",
                                                            },
                                                            maxLength: 10,
                                                        }}
                                                        control={control}
                                                        placeholder={"Enter"}
                                                        customClassName={"withBorder"}
                                                        errors={errors.PANNo}
                                                        disabled={!!watch("PANNo")}
                                                        mandatory={false}
                                                        className="text-uppercase"
                                                    />
                                                </Col><Col md="3">
                                                        <TextFieldHookForm
                                                            {...register("GISTINNumber", {
                                                                required: "GSTIN Number is required.",
                                                            })}
                                                            label="GSTIN Number"
                                                            name="GISTINNumber"
                                                            Controller={Controller}
                                                            control={control}
                                                            placeholder="Enter"
                                                            rules={{
                                                                required: false,
                                                                validate: {
                                                                    checkWhiteSpaces,
                                                                    // validatePANByGstin
                                                                },
                                                                maxLength: 15,
                                                                minLength: {
                                                                    value: 15,
                                                                    message: "Minimum length is 15 digits.",
                                                                },
                                                            }}
                                                            handleChange={(e) => {
                                                                setIsGstValid(false);
                                                                setHasGSTINChanged(true);
                                                                const uppercaseValue = e.target.value.toUpperCase(); // Convert input value to uppercase
                                                                e.target.value = uppercaseValue;
                                                            }}
                                                            customClassName="withBorder"
                                                            errors={errors?.GISTINNumber}
                                                            disabled={!!watch("PANNo")}
                                                            className="text-uppercase"
                                                            onFieldBlur={(e) => {
                                                                if (hasGSTINChanged) {
                                                                    validateGSTIN(e.target.value);
                                                                    setHasGSTINChanged(false);
                                                                }
                                                            }} />
                                                    </Col></>}
                                            <Col md="3">
                                                <TooltipCustom
                                                    id="mobileNoTooltip"
                                                    tooltipText={
                                                        <>Supplier Primary contact no. for all communication.</>
                                                    }
                                                />

                                                <TextFieldHookForm
                                                    {...register("MobileNo")}
                                                    label={`Contact Number`}
                                                    name={"MobileNo"}
                                                    Controller={Controller}
                                                    control={control}
                                                    placeholder={"Enter"}
                                                    rules={{
                                                        required: modeEdit == "edit" ? false : true,
                                                        validate: { checkWhiteSpaces, numberHavells },
                                                        maxLength: supplierOrigin == "1" ? 10 : 15,
                                                    }}
                                                    // register={register}
                                                    // className=""
                                                    customClassName={"withBorder"}
                                                    errors={errors.MobileNo}
                                                    handleChange={() => { }}
                                                    mandatory={true}
                                                    disabled={
                                                        idDataFromSupplier || modeEdit === "edit"
                                                            ? true
                                                            : false
                                                    }
                                                />
                                            </Col>
                                            <Col md="3">
                                                <TooltipCustom
                                                    id="emailTooltip"
                                                    tooltipText={
                                                        <>Supplier Primary email id for all communication.</>
                                                    }
                                                />
                                                <TextFieldHookForm
                                                    {...register("Email")}
                                                    label={`Primary Email Address`}
                                                    name={"Email"}
                                                    Controller={Controller}
                                                    control={control}
                                                    placeholder={"Enter"}
                                                    rules={{
                                                        required: true,
                                                        validate: { checkWhiteSpaces, email },
                                                        maxLength: 100,
                                                    }}
                                                    handleChange={() => { }}
                                                    customClassName={"withBorder"}
                                                    errors={errors.Email}
                                                    mandatory={true}
                                                    disabled={
                                                        idDataFromSupplier || modeEdit === "edit"
                                                            ? true
                                                            : false
                                                    }
                                                />
                                            </Col>
                                            <Col md="3">
                                                <div className="d-flex align-items-center">
                                                    <div className="fullinput-icon">
                                                        <TooltipCustom
                                                            id="businessYearTooltip"
                                                            width="350px"
                                                            tooltipText={
                                                                <>
                                                                    Please enter the value in numbers excluding
                                                                    the unit.
                                                                    <br />
                                                                    Ex- If your value is 200,000 you can simply
                                                                    write 2 in the text box as lakh is the default
                                                                    unit.
                                                                </>
                                                            }
                                                        />
                                                        <TextFieldHookForm
                                                            {...register("ExpectedBusiness")}
                                                            label={`Expected Business/Year (INR)`}
                                                            name={"ExpectedBusiness"}
                                                            Controller={Controller}
                                                            handleChange={() => { }}
                                                            rules={{
                                                                required: true,
                                                                validate: { checkWhiteSpaces, numberHavells },
                                                                maxLength: 10,
                                                            }}
                                                            control={control}
                                                            placeholder={"Enter"}
                                                            customClassName={"withBorder"}
                                                            errors={errors.ExpectedBusiness}
                                                            disabled={false}
                                                            mandatory={true}
                                                            inputWrapClass="hl-append-wrap"
                                                            appendClass="d-block-input"
                                                            appendText="Lakh"
                                                        />
                                                    </div>
                                                </div>
                                            </Col>
                                            <Col md="3">

                                                <SearchableSelectHookForm
                                                    {...register("ReasonOfBlocking")}
                                                    label="Reason For blocking"
                                                    rules={{ required: true }}
                                                    name="ReasonOfBlocking"
                                                    placeholder="Select"
                                                    Controller={Controller}
                                                    control={control}
                                                    register={register}
                                                    options={renderListing("ReasonBlockData")}
                                                    mandatory={true}
                                                    handleChange={(value) => {
                                                        handleSelectChange(value);
                                                    }}
                                                    errors={errors?.ReasonOfBlocking}
                                                    disabled={true}
                                                />
                                            </Col>
                                            <Col md="3">
                                                <SearchableSelectHookForm
                                                    {...register("PaymentTerms")}
                                                    label="Payment Terms"
                                                    rules={{ required: true }}
                                                    name="PaymentTerms"
                                                    placeholder="Select"
                                                    Controller={Controller}
                                                    control={control}
                                                    register={register}
                                                    options={renderListing("PaymentTermsData")}
                                                    mandatory={true}
                                                    handleChange={(value) => {
                                                        handleSelectChange(value);
                                                    }}
                                                    errors={errors?.PaymentTerms}
                                                    disabled={false}
                                                />
                                            </Col>
                                        </Row>
                                        <hr className="hr-seprator" />

                                        <Row className="part-detail-wrapper">
                                            <Col md="12">
                                                <HeaderTitle
                                                    title={
                                                        <>
                                                            Why Supplier Unblocking is Required <small>(Select at least one option is mandatory)</small>
                                                        </>
                                                    }
                                                    customClass="mt-4"
                                                />
                                            </Col>
                                        </Row>
                                        <Row className="part-detail-wrapper mt-3 mb-3">
                                            <Col md="3" className="mb-3">
                                                <Label>
                                                    Import Localization
                                                    <span className="asterisk-required">*</span>
                                                </Label>
                                                <Label className="d-inline-block align-middle w-auto pl-1 pr-5 mr-5 pr-4 pt-0 radio-box">
                                                    <input
                                                        type="radio"
                                                        {...register("Importlocalization")}
                                                        value="true"
                                                    // defaultChecked
                                                    />
                                                    <span>Yes</span>
                                                </Label>
                                                <Label className="d-inline-block align-middle w-auto pl0 pt-0 radio-box">
                                                    <input
                                                        type="radio"
                                                        {...register("Importlocalization")}
                                                        value="false"
                                                    />
                                                    <span>No</span>
                                                </Label>
                                            </Col>
                                            <Col md="3" className="mb-3">
                                                <Label>
                                                    Due to Single Source
                                                    <span className="asterisk-required">*</span>
                                                </Label>
                                                <Label className="d-inline-block align-middle w-auto pl-1 pr-5 mr-5 pr-4 pt-0 radio-box">
                                                    <input
                                                        type="radio"
                                                        {...register("DuetoSingleSource")}
                                                        value="true"
                                                    // defaultChecked
                                                    />
                                                    <span>Yes</span>
                                                </Label>
                                                <Label className="d-inline-block align-middle w-auto pl0 pt-0 radio-box">
                                                    <input
                                                        type="radio"
                                                        {...register("DuetoSingleSource")}
                                                        value="false"
                                                    />
                                                    <span>No</span>
                                                </Label>
                                            </Col>
                                        </Row>
                                        <hr className="hr-seprator" />
                                        <Row>
                                            <Col md="3">
                                                <Row className="part-detail-wrapper mt-2">
                                                    <Col md="12">
                                                        <Label>
                                                            Commercial Reason{" "}
                                                            <span className="asterisk-required">*</span>
                                                        </Label>
                                                    </Col>
                                                    <Col md="12">
                                                        <Label
                                                            className={
                                                                "d-inline-block align-middle w-auto pr-5 mr-5 mb-3 pt-0 radio-box pl-2"
                                                            }
                                                            check
                                                        >
                                                            <input
                                                                type="radio"
                                                                name="Commercial"
                                                                className="zero-based"
                                                                id="IsExistingSupplierTrue"
                                                                {...register("Commercial", {
                                                                    // required: true,
                                                                })}
                                                                // value={true}
                                                                value="true"
                                                            // checked={watch("IsExistingSupplier")?true:false}
                                                            />
                                                            <span>Yes</span>
                                                        </Label>
                                                        <Label
                                                            className={
                                                                "d-inline-block align-middle w-auto pl0 mb-3 pt-0 radio-box"
                                                            }
                                                            check
                                                        >
                                                            <input
                                                                type="radio"
                                                                name="Commercial"
                                                                className="vendor-based"
                                                                id="IsExistingSupplierFalse"
                                                                {...register("Commercial", {
                                                                    // required: true,
                                                                })}
                                                                // value={false}
                                                                value="false"
                                                            // checked={watch("IsExistingSupplier")?false:true}
                                                            />
                                                            <span>No</span>
                                                        </Label>
                                                    </Col>
                                                    <Col md="12">
                                                        {watch("Commercial") === "true" && (
                                                            <SearchableSelectHookForm
                                                                {...register("CommercialReason")}
                                                                label={"Reason"}
                                                                name={"CommercialReason"}
                                                                placeholder={"Select"}
                                                                Controller={Controller}
                                                                control={control}
                                                                rules={{ required: true }}
                                                                // register={register}
                                                                options={renderListing(
                                                                    "commercialReasonMasterData"
                                                                )}
                                                                mandatory={true}
                                                                handleChange={() => { }}
                                                                errors={errors.CommercialReason}
                                                                disabled={false}
                                                            />
                                                        )}
                                                    </Col>
                                                </Row>
                                            </Col>
                                            <Col md="6">
                                                <Row className="part-detail-wrapper mt-3">
                                                    <Col md="12">
                                                        <Label>
                                                            Cost Saving
                                                            <span className="asterisk-required">*</span>
                                                        </Label>
                                                    </Col>
                                                    <Col md="12">
                                                        <Label
                                                            className={
                                                                "d-inline-block align-middle w-auto pl-1 pr-5 mr-5 mb-3 pt-0 radio-box"
                                                            }
                                                            check
                                                        >
                                                            <input
                                                                type="radio"
                                                                name="CostSaving"
                                                                className="zero-based"
                                                                {...register("CostSaving", {
                                                                    required: true,

                                                                })}
                                                                onChange={(e) => setCostSaving(e.target.value)}
                                                                id="CostSavingTrue"
                                                                value="true"
                                                            />{" "}
                                                            <span>Yes</span>
                                                        </Label>
                                                        <Label
                                                            className={
                                                                "d-inline-block align-middle w-auto pl0 mb-3 pt-0 radio-box"
                                                            }
                                                            check
                                                        >
                                                            <input
                                                                type="radio"
                                                                name="CostSaving"
                                                                {...register("CostSaving", {
                                                                    required: true,
                                                                    // onChange: (e) => setCostSaving(e.target.value),
                                                                })}
                                                                onChange={(e) => setCostSaving(e.target.value)}
                                                                className="vendor-based"
                                                                id="CostSavingFalse"
                                                                value="false"
                                                            />{" "}
                                                            <span>No</span>
                                                        </Label>
                                                    </Col>
                                                    <Col md="12">
                                                        <Row>
                                                            {costSaving == "true" && (
                                                                <Col md="4">
                                                                    <TooltipCustom
                                                                        id="howMuchAnnuallyTooltip"
                                                                        tooltipText={
                                                                            <>
                                                                                Please enter the value in numbers excluding the unit.
                                                                                <br />
                                                                                Ex- If your value is 200,000 you can simply write 2 in the text box as lakh is the default unit.
                                                                            </>
                                                                        }
                                                                    />
                                                                    <TextFieldHookForm
                                                                        {...register("HowMuchAnnuallyCostSaving")}
                                                                        label={`How Much Annually`}
                                                                        name={"HowMuchAnnuallyCostSaving"}
                                                                        Controller={Controller}
                                                                        handleChange={() => { }}
                                                                        rules={{
                                                                            required: true,
                                                                            validate: {
                                                                                checkWhiteSpaces,
                                                                                numberHavells,
                                                                            },
                                                                            maxLength: 10,
                                                                        }}
                                                                        control={control}
                                                                        placeholder={"Enter"}
                                                                        customClassName={"withBorder"}
                                                                        errors={errors.HowMuchAnnuallyCostSaving}
                                                                        disabled={false}
                                                                        mandatory={true}
                                                                        inputWrapClass="hl-append-wrap"
                                                                        appendClass="d-block-input"
                                                                        appendText="Lakh"
                                                                    />
                                                                </Col>
                                                            )}
                                                            <Col md="4">
                                                                {costSaving == "true" && (
                                                                    <TextFieldHookForm
                                                                        {...register("WhatPercentAnnuallyCostSaving")}
                                                                        label={`What Percent Annually`}
                                                                        name={"WhatPercentAnnuallyCostSaving"}
                                                                        Controller={Controller}
                                                                        handleChange={() => { }}
                                                                        rules={{
                                                                            required: true,
                                                                            validate: {
                                                                                checkWhiteSpaces,
                                                                                numberHavells,
                                                                            },
                                                                            maxLength: 10,
                                                                        }}
                                                                        control={control}
                                                                        placeholder={"Enter"}
                                                                        customClassName={"withBorder"}
                                                                        errors={errors.WhatPercentAnnuallyCostSaving}
                                                                        disabled={false}
                                                                        mandatory={true}
                                                                        inputWrapClass="hl-append-wrap"
                                                                        appendClass="d-block-input"
                                                                        appendText="%"
                                                                    />
                                                                )}
                                                            </Col>
                                                            {costSaving == "true" && (
                                                                <Col md="4">
                                                                    <label>
                                                                        Upload Evidence{" "}
                                                                        <TooltipCustom
                                                                            id="evidenceTooltip"
                                                                            customClass="hl-com-profile"
                                                                            tooltipText={
                                                                                <>
                                                                                    Allowed file formats: .pdf, .xls, .doc.
                                                                                </>
                                                                            }
                                                                        />
                                                                    </label>
                                                                    <FileUpload
                                                                        uploaMainWrap="hl-ml-0 hl-upload-main"
                                                                        control={control}
                                                                        name="costSavingDocument"
                                                                        onFileChange={(file) => handleEvidenceUpload(file)}
                                                                        onDelete={handleUploadEvidenceDelete}
                                                                        setFile={() => setUploadEvidenceFile}
                                                                        uploadedFile={uploadEvidenceFile}
                                                                        setUplaodedFile={setUploadEvidenceFile}
                                                                        allowedFileTypes={[
                                                                            "application/pdf",
                                                                            "application/msword", // .doc files
                                                                            "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // .docx files
                                                                            "application/vnd.ms-excel", // .xls files
                                                                            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // .xlsx files
                                                                        ]}
                                                                    />
                                                                </Col>
                                                            )}
                                                        </Row>
                                                    </Col>
                                                </Row>
                                            </Col>
                                        </Row>
                                        <hr className="hr-seprator" />
                                        <Col md="3">
                                            <Row className="part-detail-wrapper pb-4 mt-3">
                                                <Col md="7">
                                                    <Label>
                                                        Cost Sheet
                                                        <span className="asterisk-required">*</span>
                                                    </Label>
                                                </Col>
                                                <Col md="12">
                                                    <Label
                                                        className={
                                                            "d-inline-block align-middle w-auto pl-1 pr-5 mr-5 mb-3 pt-0 radio-box"
                                                        }
                                                        check
                                                    >
                                                        <input
                                                            type="radio"
                                                            name="CostSheet"
                                                            {...register("CostSheet", {
                                                                required: true,
                                                            })}
                                                            className="zero-based"
                                                            id="CostSheetTrue"
                                                            value="true"
                                                        />{" "}
                                                        <span>Yes</span>
                                                    </Label>
                                                    <Label
                                                        className={
                                                            "d-inline-block align-middle w-auto pl0 mb-3 pt-0 radio-box"
                                                        }
                                                        check
                                                    >
                                                        <input
                                                            type="radio"
                                                            name="CostSheet"
                                                            {...register("CostSheet", {
                                                                required: true,
                                                            })}
                                                            className="vendor-based"
                                                            id="CostSheetFalse"
                                                            value="false"
                                                            disabled={costSaving == "true" || selectedCategoryCostSheet === "true"}
                                                        />{" "}
                                                        <span>No</span>
                                                    </Label>
                                                </Col>
                                                <Col md="12">
                                                    {watch("CostSheet") === "true" && (
                                                        <>
                                                            <label>
                                                                Upload Cost Sheet Document
                                                                <TooltipCustom
                                                                    id="costSheetTooltip"
                                                                    customClass="hl-com-profile"
                                                                    tooltipText={
                                                                        <>
                                                                            Allowed file formats: .pdf, .xls, .doc.
                                                                        </>
                                                                    }
                                                                />
                                                            </label>
                                                            <FileUpload
                                                                {...register("CostSheetDocument")}
                                                                uploaMainWrap="hl-ml-0 hl-upload-main"
                                                                control={control}
                                                                name="CostSheetDocument"
                                                                onFileChange={(file) => handleCostSheetDocument(file)}
                                                                onDelete={() => {
                                                                    setValue("CostSheetDocument", null);
                                                                    setIsoFile((p) => ({
                                                                        ...p,
                                                                        isRemove: true,
                                                                    }));
                                                                }}
                                                                setFile={() => setIsoFile}
                                                                uploadedFile={isoFile}
                                                                setUplaodedFile={setIsoFile}
                                                                allowedFileTypes={[
                                                                    "application/pdf",
                                                                    "application/msword", // .doc files
                                                                    "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // .docx files
                                                                    "application/vnd.ms-excel", // .xls files
                                                                    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // .xlsx files
                                                                ]}
                                                                rules={{ required: "File required" }}
                                                                errors={errors?.CostSheetDocument}
                                                            />
                                                        </>
                                                    )}
                                                </Col>
                                            </Row>
                                        </Col>
                                        <hr className="hr-seprator" />
                                        <Row className="part-detail-wrapper pb-5 mt-3">
                                            <Col md="6">
                                                <TextAreaHookForm
                                                    label={
                                                        <>
                                                            Why Supplier Unblocking is Required
                                                            <span className="asterisk-required">*</span>
                                                            <TooltipCustom
                                                                id="partFgTooltip"
                                                                tooltipText={
                                                                    <>Please enter specific remarks for supplier code unblocking
                                                                        instead of why supplier code unblocking is required</>
                                                                }
                                                            />
                                                        </>
                                                    }
                                                    name={"Remarks"}
                                                    rules={{
                                                        required: true,
                                                        validate: { checkWhiteSpaces, alphaNumericHavells },
                                                        maxLength: 1000,
                                                    }}
                                                    placeholder={true ? "Enter" : "Enter"}
                                                    Controller={Controller}
                                                    control={control}
                                                    register={register}
                                                    mandatory={false}
                                                    customClassName={"withBorder"}
                                                    handleChange={handleRemarksChange} // Pass the event handler
                                                    errors={errors.Remarks}
                                                    disabled={false}
                                                    rowHeight={2}
                                                />
                                            </Col>

                                        </Row>
                                        <Row className="justify-content-between sf-btn-footer no-gutters justify-content-between bottom-footer sticky-btn-footer hl-btm-footer">
                                            <div className="col-sm-12 text-right bluefooter-butn">
                                                <button
                                                    type={"button"}
                                                    className="reset mr-2 cancel-btn"
                                                    onClick={cancel}
                                                >
                                                    <div className={"cancel-icon"}></div>
                                                    {"Cancel"}
                                                </button>
                                                <button
                                                    type="submit"
                                                    className="submit-button save-btn"

                                                >
                                                    <div className="send-for-approval mr-1"></div>
                                                    {"Submit"}
                                                </button>
                                            </div>
                                        </Row>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

        </>
    );
}
export default AddUnblockingRequest;
